module.exports = __webpack_public_path__ + "img/fig41.449f76ef.jpg";